<form [formGroup]="form">
  <div class="prijava-modal-container">
    <h3 class="frida-modal-title">Prijava</h3>
    <div *ngIf="status === PRIJAVA_STATUS.WAITING || status === PRIJAVA_STATUS.SENDING">
      <p>Tukaj se prijavite za izbrano aktivnost. Po elektronski pošti ali telefonu vam bomo potrdili udeležbo.</p>
      <div class="frida-input-label">Ime in priimek</div>
      <input formControlName="Ime in priimek" id="Ime in priimek" type="text" class="frida-input">

      <div class="frida-input-label">E-pošta</div>
      <input formControlName="E-pošta" id="E-pošta" type="email" class="frida-input">

      <div class="frida-input-label">Telefon</div>
      <input formControlName="Telefon" id="Telefon" class="frida-input">
      <div *ngIf="invalid">
        <br/>
        <br/>
        <div class="form-warning">Izpolnite vsa polja in poskusite ponovno.</div>
      </div>
      <br/><br/>
      <app-button [disabled]="status === PRIJAVA_STATUS.SENDING" text="Oddaj prijavo" (click)="onPrijavaClick()"
                  buttonType="BLOCK"></app-button>
      <div class="modal-close-button" (click)="closeWindow()">Zapri okno</div>
    </div>
    <div class="sent-window" *ngIf="status === PRIJAVA_STATUS.SENT">
      <p class="success-label"><b>Uspešno ste oddali prijavo!</b></p>
      <p>Po elektronski pošti ali telefonu vam bomo potrdili udeležbo.</p>
      <app-button text="Zapri okno" (click)="closeWindow()"
                  buttonType="BLOCK"></app-button>
    </div>
  </div>
</form>
